module.exports = __webpack_public_path__ + "img/banner-img-sm.e309e0d9.png";